import RestService from "~/core/services/rest.service";
import type { CartographySettings } from "~/modules/cartography/models/CartographySettings.interface";

class CartographyService extends RestService {
  getCartographySettings(): Promise<CartographySettings> {
    return this.$api.get("cartography/settings");
  }
}

export default new CartographyService();
